import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
      gap: '16px',
    },
    analyzeButton: {
      width: '100%',
      margin: '0px',
      marginTop: 'auto',
      marginBottom: '16px',
    },
  }),
)
